export default __webpack_public_path__ + "static/media/V250_SOV.b848679c.pdf";